import React, {useCallback, useRef} from 'react'
import {useIntl} from 'react-intl'
import {filterMessages} from 'components/Filters/filterMessages'
import {useFiltersForm} from 'hooks/useFiltersForm'
import {useFreezableFilter} from 'hooks/useFreezableFilter'

import {Icon} from '@vio/atlas/Icon'
import {Pill} from '@vio/atlas/Pill'

const filterKeys = ['dealFreeze']

interface Props {
  isActive?: boolean
}
// Added as a part of c747927f-deal-freeze-srp
export const DealFreezePill: React.FC<Props> = ({isActive = false}) => {
  const {formatMessage} = useIntl()
  const buttonRef = useRef<HTMLButtonElement>(null)
  const isFreezableFilterEnabled = useFreezableFilter()

  const {submitFilters} = useFiltersForm(filterKeys)

  const handlePillClick = useCallback(() => {
    buttonRef.current?.blur()

    const updatedFilters = {
      dealFreeze: (isActive ? undefined : '1') as BooleanUrlParam
    }

    submitFilters(updatedFilters)
  }, [isActive, submitFilters])

  if (!isFreezableFilterEnabled) return null

  return (
    <Pill
      ref={buttonRef}
      isSelected={isActive}
      dataId="freezableFilter"
      onClick={handlePillClick}
      iconStart={<Icon name="Ice" />}
      iconEnd={isActive && <Icon name={'Close'} />}
    >
      {formatMessage(filterMessages.freezable)}
    </Pill>
  )
}
